import React from 'react';
import classNames from 'classnames/bind';
import { Typography } from 'gd-design-library';
import styles from '../ProductStaticContent.module.scss';
import { ImageTransformation, ProductDetailsImageRowItem } from '@services';
import { ALL_IMAGES_TRANSFORMATIONS } from '@utils';

const CN = 'product-static-content';
const productDetailsItemClassName = `${CN}__product-details-item`;
const productDetailsItemTitleClassName = `${productDetailsItemClassName}__title`;
const imageRowClassName = `${productDetailsItemClassName}__image-row`;
const cx = classNames.bind(styles);

interface Props {
  productDetailsItem: ProductDetailsImageRowItem;
}

export const ImageRow: React.FC<Props> = ({
  productDetailsItem: {
    image_row: {
      title,
      images
    }
  }
}) => {
  const imageTransformation = new ImageTransformation();

  return (
    <div className={ cx(productDetailsItemClassName) }>
      <Typography className={ cx(productDetailsItemTitleClassName) } variant='h4' >
        {title}
      </Typography>
      <div className={ cx(imageRowClassName) } >
        {images.map(image => (
          <img
            key={ image.public_id }
            src={ imageTransformation.transformById(
              image.public_id,
              ALL_IMAGES_TRANSFORMATIONS
            ) }
          />
        ))}
      </div>
    </div>
  );
};
